var sizes = {
  phone: 576,
  tablet: 768,
  desktop: 992,
  fullDesktop: 1160,
  maxDesktop: 1440
};
export default sizes;

// Media Queries

export var tabletMedia = "(min-width: ".concat(sizes.tablet, "px)");
export var tabletMediaQuery = "@media ".concat(tabletMedia);
export var desktopMedia = "(min-width: ".concat(sizes.desktop, "px)");
export var desktopMediaQuery = "@media ".concat(desktopMedia);
export var fullDesktopMedia = "(min-width: ".concat(sizes.fullDesktop, "px)");
export var fullDesktopMediaQuery = "@media ".concat(fullDesktopMedia);
export var maxDesktopMedia = "(min-width: ".concat(sizes.maxDesktop, "px)");
export var maxDesktopMediaQuery = "@media ".concat(maxDesktopMedia);